<mat-form-field class="search-form-field" appearance="outline" subscriptSizing="dynamic"
    [style.--custom-bg-color]="backgroundColor" [style.--custom-value-color]="valueColor" [floatLabel]="noFloatLabel ? 'never' : 'auto'">
    <mat-label *ngIf="!noFloatLabel">
        {{ label | translate }}
    </mat-label>

    <mat-select *ngIf="!disabled" [(value)]="selectedItem" [compareWith]="compareFn" #searchSelect name="select"
        [disabled]="disabled" [placeholder]="noFloatLabel ? (label | translate) : ''"
        (selectionChange)="onSelectionChanged($event)" (openedChange)="onSelectOpen()">
        <mat-option class="search-select">
            <mat-icon class="search-icon">search</mat-icon>

            <input class="search-input" matInput name="searchItem" [placeholder]="searchPlaceholder"
                (input)="filterItems($event)" autocomplete="off" [(ngModel)]="searchValue" (focus)="onSearchFocus()"
                (click)="$event.stopPropagation()" (keydown)="inputKeyDown($event)" #searchInput />
        </mat-option>

        <mat-option *ngFor="let item of filteredItems; let i = index" [value]="valueKey ? item[valueKey] : item"
            [id]="'option-' + id + '-' +i">
            {{ labelKey ? item[labelKey] : item }}
        </mat-option>

        <mat-option *ngIf="filteredItems.length === 0" disabled class="no-data-option">
            <lib-no-data [message]="searchValue ? 'form.search_no_data' : 'events.empty_data_short'" icon="search_off"
                size="small">
            </lib-no-data>
        </mat-option>
    </mat-select>

    <input *ngIf="disabled" type="text" [value]="getLabel()" name="id" aria-label="text" matInput readonly>
</mat-form-field>